import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { path } from 'ramda';

import { selectLocation } from '../store/location/selectors';
import { getEnvironment } from '../store/environment/selectors';

/**
 * Display a AppsFlyer banner, if the SDK is present.
 * The initialization of the AppsFlyer SDK is done in main.html.
 */
export const useSmartBanner = () => {
  const { pathname } = useSelector(selectLocation);
  const { DIETBET_AF_SMART_BANNER_KEY } = useSelector(getEnvironment);

  useEffect(() => {
    // SDK initialized?
    if (!path(['AF', 'Banner'], window)) return;

    if (pathname.startsWith('/dietbet')) {
      window.AF.Banner.showBanner({ webkey: DIETBET_AF_SMART_BANNER_KEY });
    } else {
      window.AF.Banner.hideBanner();
    }
  }, [DIETBET_AF_SMART_BANNER_KEY, pathname]);
};
